import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import EmptyStateNoRecord from '../lib/EmptyStateNoRecord';
import Loading from '../common/Loading';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import { Button, Card } from 'react-bootstrap';
import AccountObligation from './AccountObligation';
import AccountAsset from './AccountAsset';

const AccountToken = (props) => {
    const { address } = props;
    const [ assets, setAssets ] = useState([]);
    const [ obligations, setObligations] = useState([]);
    const [ loading, setLoading ] = useState(false);

    // Fetch Tokens
    useEffect(() => {
        setLoading(true);
        fetch(`${XRPSCAN_API_URL}/account/${address}/assets`)
            .then(handleResponse)
            .then((data) => {
                setAssets(data);
            })
            .catch(() => {
                setAssets([])
            })
            .finally(() => {
                setLoading(false);
            });
            return () => {
                setAssets([]);
            }
    }, [address]);

    // Fetch Issued Tokens
    useEffect(() => {
        setLoading(true);
        fetch(`${XRPSCAN_API_URL}/account/${address}/obligations`)
            .then(handleResponse)
            .then((data) => {
                setObligations(data);
            })
            .catch(() => {
                setObligations([])
            })
            return () => {
                setObligations([]);
            }
    }, [address]);

    if (loading) {
        return <Loading/>;
    }

    return (
        <>
            {obligations?.length > 0 &&
            <Card className='shadow-sm border-info'>
                <Card.Body>
                    <Card.Text>
                        <h6>Tokens issued</h6>
                    </Card.Text>
                    <AccountObligation obligations={obligations} address={address} />
                </Card.Body>
            </Card>
            }
            {assets?.length > 0 &&
            <Card className='shadow-sm'>
                <Card.Body>
                    <Card.Text>
                        <h6>Tokens owned</h6>
                    </Card.Text>
                    <AccountAsset assets={assets}/>
                </Card.Body>
            </Card>
            }
            {!loading && obligations?.length === 0 && assets?.length === 0 &&
                <EmptyStateNoRecord title="No tokens">
                    <div className='mb-3'>This account does not own any tokens.</div>
                    <Link to="/tokens">
                        <Button variant="info" size="sm">Browse all Tokens &rarr;</Button>
                    </Link>
                </EmptyStateNoRecord>
            }
        </>
    )
}

AccountToken.propTypes = {
    address: PropTypes.string.isRequired,
}

export default AccountToken;